<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      v-model="model"
      :error="errors"
      id="input-bank_account_swift"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import InputWidget from "../../../core/InputWidget";
import BaseInputMixin from "@/mixins/profileInputMixin";

export default {
  name: "BankAccountSwift",
  components: {InputWidget},
  mixins: [BaseInputMixin('bank_account.swift')],

  data() {
    return {
      name: 'swift',
      defaultLabel: this.$t("Swift")
    }
  }
}
</script>

<style scoped>

</style>
